export default function CrocL() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 600 207">
      <path
        fill="#BFE4C8"
        fillRule="evenodd"
        d="M600 42.425v18.181l-6.061 6.06-12.121 18.183V66.666h-12.121l-6.061 18.181-12.121-18.181h-12.121l-6.061 18.181-6.06-18.181h-18.182l-6.061 18.181-12.121-18.181h-18.182l-6.06 18.181-6.061-18.181h-12.121v18.181l30.303 6.061 6.06-12.121L496.97 96.97h12.121l12.121-12.121 12.121 18.181h12.122l6.06-18.181 18.182 30.303 18.182-18.182v42.424l-230.303 6.061v30.303l24.242 30.303h-66.667l-18.181-42.425h-200v18.182l24.242 24.243H48.485l-6.06-24.243v-30.303L0 145.455V24.242h6.06v-12.12l42.425 18.181V6.061L96.97 30.303V6.061l54.545 24.242V6.061l42.424 24.242V0l42.425 24.242h121.212l38.603 1.93c3.849-8.297 12.254-14.051 22.003-14.051 10.606 0 19.621 6.81 22.91 16.297l137.003 6.85a12.103 12.103 0 0 1 9.784-4.965c4.452 0 8.343 2.4 10.45 5.977l1.671.084v6.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
